var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInformation4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 202 202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M98.432 179.287c44.656 0 80.857-20.901 80.857-46.685 0-25.783-36.201-46.684-80.857-46.684s-80.857 20.901-80.857 46.684c0 25.784 36.2 46.685 80.857 46.685z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M126.873 184.669l61.994-35.792c1.358-.784 1.358-2.054 0-2.838L74.911 80.532a5.442 5.442 0 0 0-4.92 0L7.997 116.304c-1.358.804-1.358 2.058 0 2.842l113.96 65.515a5.436 5.436 0 0 0 4.916.008zM173.746 187.261a1.585 1.585 0 0 1-1.306-.736l-10.258-14.393a1.532 1.532 0 0 1-.201-1.636 1.424 1.424 0 0 1 1.299-.751c.158.002.316.02.47.056l25.595 6.085c1.23.294 1.254 1.162 1.234 1.419-.02.257-.193 1.109-1.455 1.206l-12.645.804-1.27 6.604a1.51 1.51 0 0 1-1.467 1.338l.004.004z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M126.507 43.759a.673.673 0 0 0-.402-.535 2.112 2.112 0 0 0-1.913 0 .676.676 0 0 0-.402.535v61.966h2.705V43.759h.012z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M126.507 43.759c0-.402-.603-.764-1.351-.764-.747 0-1.35.342-1.35.764s.603.767 1.35.767c.748 0 1.351-.345 1.351-.767z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M132.922 57.352L115.277 47.16l-2.653 1.532 2.653 4.594 17.645 10.197v-6.13z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M132.922 57.352L115.277 47.16l-2.653 1.532 2.653 4.594 17.645 10.197v-6.13z",
    opacity: 0.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M115.277 47.16l1.326-.768L134.272 56.6l-1.35.751-17.645-10.193z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M115.277 47.16l1.326-.768L134.272 56.6l-1.35.751-17.645-10.193z",
    opacity: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M134.272 62.73l-1.35.752v-6.13l1.35-.751v6.13z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M134.272 62.73l-1.35.752v-6.13l1.35-.751v6.13z",
    opacity: 0.55
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M125.583 56.567a.137.137 0 0 1-.051-.052.139.139 0 0 1-.019-.07v-1.526c0-.024.006-.04.019-.047.013-.008.03-.006.051.006l.322.189a.13.13 0 0 1 .05.055.13.13 0 0 1 .023.069v.13c.103-.081.241-.07.415.031l.123.072a.144.144 0 0 1 .07.122v.335c0 .021-.006.037-.019.047-.014.007-.03.005-.051-.007l-.272-.16c-.076-.044-.136-.054-.179-.03-.041.024-.062.08-.062.17v.83c0 .024-.007.04-.022.046-.013.007-.03.005-.051-.007l-.347-.203zm1.862 1.12a1.463 1.463 0 0 1-.53-.52 1.464 1.464 0 0 1-.202-.732v-.113c.007-.251.076-.41.205-.478.13-.069.305-.039.524.089a1.458 1.458 0 0 1 .647.797c.056.163.084.329.084.498v.077c0 .022-.006.038-.019.047-.013.008-.03.006-.051-.006l-.897-.525v.023a.732.732 0 0 0 .065.284c.039.086.096.15.171.194.046.028.085.04.115.035a.2.2 0 0 0 .081-.037c.017-.014.03-.02.039-.019.011 0 .028.007.051.02l.347.203c.017.01.031.025.042.044.013.019.02.038.02.057 0 .056-.028.105-.084.146-.054.042-.134.059-.238.052a.88.88 0 0 1-.37-.135zm.235-.91v-.007a.632.632 0 0 0-.064-.288.445.445 0 0 0-.174-.195c-.073-.043-.131-.045-.174-.008-.041.037-.062.108-.062.214v.007l.474.277zm1.429 1.884a1.471 1.471 0 0 1-.53-.52 1.465 1.465 0 0 1-.202-.733v-.113c.008-.251.076-.41.205-.478.131-.069.305-.039.524.089a1.485 1.485 0 0 1 .648.797c.056.163.084.329.084.498v.077c0 .022-.007.038-.02.047-.013.008-.03.006-.05-.006l-.897-.525v.023a.731.731 0 0 0 .064.284c.039.086.096.15.171.194.047.028.085.04.115.035a.2.2 0 0 0 .081-.037c.017-.014.03-.02.04-.019.011 0 .028.007.05.02l.348.203c.016.01.03.025.042.044a.097.097 0 0 1 .019.057c0 .056-.028.105-.084.146-.054.042-.133.059-.238.052a.88.88 0 0 1-.37-.135zm.235-.911v-.007a.632.632 0 0 0-.064-.288.433.433 0 0 0-.174-.195c-.073-.043-.131-.045-.174-.008-.041.037-.061.108-.061.214v.007l.473.277zm1.497 1.89c-.387-.225-.581-.552-.581-.978v-.623l-.218-.128a.145.145 0 0 1-.053-.054.13.13 0 0 1-.02-.07v-.263c0-.024.006-.04.02-.047.014-.006.032-.004.053.008l.218.128v-.536c0-.023.007-.04.02-.047.015-.006.032-.004.05.007l.326.19c.02.012.037.03.05.053a.14.14 0 0 1 .02.07v.535l.35.205c.021.012.038.03.051.052a.133.133 0 0 1 .022.072v.263c0 .024-.007.039-.022.045-.013.008-.03.005-.051-.007l-.35-.205v.578c0 .16.053.272.16.334l.215.126c.021.012.038.03.051.053a.139.139 0 0 1 .019.07v.282c0 .022-.006.037-.019.047-.013.008-.03.005-.051-.007l-.26-.152z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M176.628 136.413l-2.159-1.861s.085-6.656 2.03-12.01c2.741-7.528 8.549-9.176 10.322-8.039 1.772 1.138 1.772 3.533-2.569 7.348-2.564 2.259-6.286 7.343-7.624 14.562z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M176.628 136.413l-2.159-1.861s.085-6.656 2.03-12.01c2.741-7.528 8.549-9.176 10.322-8.039 1.772 1.138 1.772 3.533-2.569 7.348-2.564 2.259-6.286 7.343-7.624 14.562z",
    opacity: 0.15
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M176.351 133.145h.024a.176.176 0 0 0 .185-.169c.401-7.464 4.887-14.871 8.794-17.436a.183.183 0 0 0 .077-.109.195.195 0 0 0 .001-.068.175.175 0 0 0-.138-.139.178.178 0 0 0-.133.023c-3.983 2.617-8.537 10.133-8.955 17.709a.172.172 0 0 0 .036.122.174.174 0 0 0 .109.067z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M182.99 141.626c.342.293 1.23-.037 1.572-.181a3.673 3.673 0 0 0 1.491-1.162c.439-.58.687-1.282.708-2.01a7.74 7.74 0 0 0-.049-1.149l-.096-1.125a2.749 2.749 0 0 1 .052-1.106c.233-.707.981-1.093 1.652-1.419.748-.361 1.547-.872 1.716-1.748a3.154 3.154 0 0 0-.402-1.986c-.317-.615-.723-1.181-.992-1.812a2.168 2.168 0 0 1-.177-1.451c.096-.297.254-.571.462-.804.462-.474.886-.985 1.266-1.527a1.75 1.75 0 0 0 .032-1.853 2.03 2.03 0 0 0-1.435-.668 3.485 3.485 0 0 0-1.499.222c-1.543.502-2.661 2.009-4.252 2.303-.622.069-1.248.099-1.873.088a2.275 2.275 0 0 0-1.672.723c-.752.977 0 2.509-.611 3.586-.539.952-1.608 1.149-2.336 1.957-.305.361-.487.81-.518 1.282a6.466 6.466 0 0 0 .125 2.36c.221.776.502 1.533.84 2.267l5.996 5.213z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M179.458 138.772a.179.179 0 0 0 .18-.08.17.17 0 0 0 .024-.065c1.054-6.941 5.776-13.907 8.566-15.655a.187.187 0 0 0 .076-.109.184.184 0 0 0-.02-.132.181.181 0 0 0-.111-.08.178.178 0 0 0-.134.024c-2.846 1.78-7.657 8.862-8.726 15.896a.177.177 0 0 0 .145.201z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M182.074 130.822h.052a23.712 23.712 0 0 1 5.149.165.185.185 0 0 0 .133-.033.184.184 0 0 0 .07-.186.176.176 0 0 0-.081-.109.172.172 0 0 0-.066-.022 24.216 24.216 0 0 0-5.245-.169.173.173 0 0 0-.107.06.175.175 0 0 0 0 .23.178.178 0 0 0 .107.06l-.012.004z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M63.93 55.696l-2.01 1.162a2.025 2.025 0 0 0 0-.265v-.583c0-1.037-.727-1.455-1.607-.937a3.164 3.164 0 0 0-.97.929c-.144-1.302-1.169-1.789-2.41-1.07a5.362 5.362 0 0 0-2.412 4.209v.852a2.33 2.33 0 0 0 .205 1.009l-1.668.965a2.01 2.01 0 0 0-.9 1.56c0 .574.401.803.9.522l10.888-6.287a2.011 2.011 0 0 0 .9-1.56c-.024-.558-.426-.791-.916-.506zM72.278 60.873l-1.475.852a1.702 1.702 0 0 0 0-.196v-.427c0-.76-.535-1.069-1.206-.687a2.285 2.285 0 0 0-.707.684c-.109-.957-.856-1.31-1.769-.804a3.939 3.939 0 0 0-1.78 3.087v.639a1.68 1.68 0 0 0 .148.74l-1.205.707a1.447 1.447 0 0 0-.66 1.141c0 .422.294.59.66.382l7.994-4.586a1.448 1.448 0 0 0 .66-1.142c0-.43-.294-.599-.66-.39z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M183.424 137.912c.856.663.764 1.608-.273 2.199l-56.749 32.765a4.58 4.58 0 0 1-4.128 0L13.825 110.259c-1.053-.607-1.137-1.559-.245-2.218a4.585 4.585 0 0 0-1.813 3.4v2.729a4.542 4.542 0 0 0 2.066 3.577l108.433 62.625a4.564 4.564 0 0 0 4.132 0l56.749-32.757a4.556 4.556 0 0 0 1.46-1.539 4.556 4.556 0 0 0 .602-2.034v-2.734a4.605 4.605 0 0 0-1.785-3.396z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M183.151 137.731L74.698 75.114a4.595 4.595 0 0 0-4.128 0L13.825 107.88c-1.141.655-1.141 1.724 0 2.379l108.449 62.617a4.58 4.58 0 0 0 4.128 0l56.749-32.765c1.138-.655 1.138-1.741 0-2.38z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M13.58 108.041a4.585 4.585 0 0 0-1.813 3.4v2.729a4.552 4.552 0 0 0 2.066 3.577l108.433 62.625a4.23 4.23 0 0 0 2.07.495v-7.5a4.257 4.257 0 0 1-2.066-.491L13.825 110.259c-1.053-.607-1.137-1.559-.245-2.218z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.566 97.22c.58-.333.58-.875 0-1.205a2.298 2.298 0 0 0-2.098 0c-.583.334-.583.876 0 1.206a2.323 2.323 0 0 0 2.098 0zM44.404 95.387l8.099-4.674c.486-.277.51-.72.056-.98a1.886 1.886 0 0 0-1.696.031l-8.099 4.679c-.482.277-.506.715-.056.977a1.873 1.873 0 0 0 1.696-.033z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M78.371 80.138c-.972-.562-2.01-.237-2.966.33L22.35 111.07c-.977.563-.98 1.475 0 2.042l96.259 55.587a3.916 3.916 0 0 0 3.541 0l53.055-30.607c.981-.563.977-1.479 0-2.042L78.371 80.138z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M78.371 80.138c-.972-.562-2.01-.237-2.966.33L22.35 111.07c-.977.563-.98 1.475 0 2.042l96.259 55.587a3.916 3.916 0 0 0 3.541 0l53.055-30.607c.981-.563.977-1.479 0-2.042L78.371 80.138z",
    opacity: 0.96
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#7764F5",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.393 167.8l19.993-11.536-3.357-.968a40.675 40.675 0 0 0-31.612 3.854l14.976 8.65zM143.822 154.275l29.852-17.235-19.98-11.532-11.789 28.216 1.917.551zM150.366 123.583l-11.656 29.216c-6.89-2.186-13.071-2.52-20.149-1.302l11.254-27.709 16.35-2.629 4.201 2.424zM113.404 152.619l4.084-10.049-31.725-3.762-5.326 5.925 22.107 12.765a45.27 45.27 0 0 1 10.86-4.879zM133.778 114.017l9.928 5.72-13.107 2.118 3.179-7.838zM70.445 118.893c1.952 0 3.533-.913 3.533-2.038 0-1.126-1.581-2.038-3.533-2.038-1.95 0-3.533.912-3.533 2.038 0 1.125 1.582 2.038 3.533 2.038zM124.891 123.985l-49.072-5.816c-.518 1.182-1.403 1.447-3.465 1.897l13.69 15.675 32.637 3.835 6.21-15.591zM101.575 109.178l-3.617 8.742-22.284-2.645a5.086 5.086 0 0 0-1.913-1.234l3.06-7.797 24.754 2.934zM129.972 111.81l-3.831 9.449-24.437-2.897 3.838-9.45 24.43 2.898zM125.39 109.161L84.91 85.793l-7.009 17.737 47.489 5.631zM67.483 119.789l14.948 17.094-5.326 5.908-28.895-16.68 17.818-6.993c.457.28.945.506 1.455.671zM74.61 103.141L82.1 84.169l-4.996-2.881L45.28 99.66l29.33 3.481zM41.02 102.076l-17.195 9.972 21.644 12.496 19.092-7.524c-.04-.917.402-1.797 1.8-2.617 1.15-.663 2.585-.912 4.173-.949l2.978-7.6-32.492-3.778z",
    opacity: 0.4
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M79.57 102.494v-5.953l9.191 1.09v5.948l-9.192-1.085zM88.761 97.63l1.894-5.301v6.563l-1.894 4.687V97.63z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M90.654 92.329l-8.995-1.085-2.09 5.297 9.192 1.09 1.894-5.302z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M79.57 102.494v-5.953l9.191 1.09v5.948l-9.192-1.085z",
    opacity: 0.8
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M88.761 97.63l1.894-5.301v6.563l-1.894 4.687V97.63z",
    opacity: 0.75
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M90.654 92.329l-8.995-1.085-2.09 5.297 9.192 1.09 1.894-5.302z",
    opacity: 0.9
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M85.594 115.203v-2.665l9.196 1.085v2.669l-9.196-1.089zM94.79 113.623l1.64-4.594v3.28l-1.64 3.983v-2.669zM96.43 109.029l-9-1.085-1.836 4.594 9.196 1.085 1.64-4.594z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M85.594 115.203v-2.665l9.196 1.085v2.669l-9.196-1.089z",
    opacity: 0.8
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M94.79 113.623l1.64-4.594v3.28l-1.64 3.983v-2.669z",
    opacity: 0.75
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M96.43 109.029l-9-1.085-1.836 4.594 9.196 1.085 1.64-4.594z",
    opacity: 0.9
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M103.299 150.295v-5.948l9.193 1.085v5.953l-9.193-1.09z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M112.491 145.432l1.898-5.297v6.563l-1.898 4.687v-5.953z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M114.389 140.135l-8.996-1.086-2.094 5.298 9.193 1.085 1.897-5.297z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M103.299 150.295v-5.948l9.193 1.085v5.953l-9.193-1.09z",
    opacity: 0.8
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M112.491 145.432l1.898-5.297v6.563l-1.898 4.687v-5.953z",
    opacity: 0.75
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M114.389 140.135l-8.996-1.086-2.094 5.298 9.193 1.085 1.897-5.297z",
    opacity: 0.9
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M103.142 105.171v-2.191l4.655.551v2.19l-4.655-.55zM107.797 103.531l.956-2.685v2.504l-.956 2.371v-2.19z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M108.753 100.846l-4.553-.547-1.058 2.681 4.655.551.956-2.685z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M103.142 105.171v-2.191l4.655.551v2.19l-4.655-.55z",
    opacity: 0.8
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M107.797 103.531l.956-2.685v2.504l-.956 2.371v-2.19z",
    opacity: 0.75
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M108.753 100.846l-4.553-.547-1.058 2.681 4.655.551.956-2.685z",
    opacity: 0.9
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M69.227 94.833v-3.191l6.769.8v3.19l-6.769-.8z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M75.996 92.441l1.395-3.898v3.641l-1.395 3.449V92.44z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M77.39 88.543l-6.623-.8-1.54 3.898 6.769.8 1.395-3.898z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M69.227 94.833v-3.191l6.769.8v3.19l-6.769-.8z",
    opacity: 0.8
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M75.996 92.441l1.395-3.898v3.641l-1.395 3.449V92.44z",
    opacity: 0.75
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M77.39 88.543l-6.623-.8-1.54 3.898 6.769.8 1.395-3.898z",
    opacity: 0.9
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M103.95 117.59v-2.841l6.037.711v2.846l-6.037-.716z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M109.987 115.46l1.242-3.477v3.248l-1.242 3.075v-2.846z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M111.229 111.983l-5.904-.711-1.375 3.477 6.037.711 1.242-3.477z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M103.95 117.59v-2.841l6.037.711v2.846l-6.037-.716z",
    opacity: 0.8
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M109.987 115.46l1.242-3.477v3.248l-1.242 3.075v-2.846z",
    opacity: 0.75
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M111.229 111.983l-5.904-.711-1.375 3.477 6.037.711 1.242-3.477z",
    opacity: 0.9
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M76.57 114.198v-2.926l6.21.731v2.931l-6.21-.736zM82.78 112.003l1.279-3.577v3.34l-1.278 3.168v-2.931z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M84.059 108.426l-6.073-.731-1.415 3.577 6.21.732 1.278-3.578z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M76.57 114.198v-2.926l6.21.731v2.931l-6.21-.736z",
    opacity: 0.8
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M82.78 112.003l1.279-3.577v3.34l-1.278 3.168v-2.931z",
    opacity: 0.75
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M84.059 108.426l-6.073-.731-1.415 3.577 6.21.732 1.278-3.578z",
    opacity: 0.9
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M111.76 118.491v-2.846l6.037.715v2.846l-6.037-.715z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M117.797 116.361l1.242-3.477v3.243l-1.242 3.079v-2.845zM119.039 112.883l-5.904-.715-1.375 3.477 6.037.715 1.242-3.477z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M111.76 118.491v-2.846l6.037.715v2.846l-6.037-.715z",
    opacity: 0.8
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117.797 116.361l1.242-3.477v3.243l-1.242 3.079v-2.845z",
    opacity: 0.75
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M119.039 112.883l-5.904-.715-1.375 3.477 6.037.715 1.242-3.477z",
    opacity: 0.9
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M119.569 119.391v-2.846l6.033.716v2.842l-6.033-.712zM125.602 117.261l1.246-3.481v3.247l-1.246 3.075v-2.841z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M126.848 113.78l-5.904-.712-1.375 3.477 6.033.716 1.246-3.481z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M119.569 119.391v-2.846l6.033.716v2.842l-6.033-.712z",
    opacity: 0.8
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M125.602 117.261l1.246-3.481v3.247l-1.246 3.075v-2.841z",
    opacity: 0.75
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M126.848 113.78l-5.904-.712-1.375 3.477 6.033.716 1.246-3.481z",
    opacity: 0.9
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M47.342 109.901v-2.845l6.037.715v2.846l-6.037-.716zM53.38 107.771l1.241-3.477v3.244l-1.242 3.079v-2.846z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M54.621 104.295l-5.904-.716-1.375 3.477 6.037.715 1.242-3.476z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.342 109.901v-2.845l6.037.715v2.846l-6.037-.716z",
    opacity: 0.8
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M53.38 107.771l1.241-3.477v3.244l-1.242 3.079v-2.846z",
    opacity: 0.75
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54.621 104.295l-5.904-.716-1.375 3.477 6.037.715 1.242-3.476z",
    opacity: 0.9
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M55.152 110.802v-2.846l6.037.715v2.842l-6.037-.711zM61.189 108.672l1.242-3.481v3.248l-1.242 3.074v-2.841z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M62.43 105.191l-5.904-.712-1.374 3.477 6.037.716 1.242-3.481z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.152 110.802v-2.846l6.037.715v2.842l-6.037-.711z",
    opacity: 0.8
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M61.189 108.672l1.242-3.481v3.248l-1.242 3.074v-2.841z",
    opacity: 0.75
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M62.43 105.191l-5.904-.712-1.374 3.477 6.037.716 1.242-3.481z",
    opacity: 0.9
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M62.961 111.698v-2.842l6.033.715v2.842l-6.033-.715zM68.994 109.572l1.246-3.481v3.247l-1.246 3.075v-2.841z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M70.24 106.091l-5.908-.712-1.37 3.477 6.032.716 1.246-3.481z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M62.961 111.698v-2.842l6.033.715v2.842l-6.033-.715z",
    opacity: 0.8
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M68.994 109.572l1.246-3.481v3.247l-1.246 3.075v-2.841z",
    opacity: 0.75
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M70.24 106.091l-5.908-.712-1.37 3.477 6.032.716 1.246-3.481z",
    opacity: 0.9
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M140.888 100.774v-1.692l5.117.602v1.693l-5.117-.603z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M140.888 100.774v-1.692l5.117.602v1.693l-5.117-.603z",
    opacity: 0.8
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M146.005 99.684l.747-2.194v2.058l-.747 1.828v-1.692z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M146.005 99.684l.747-2.194v2.058l-.747 1.828v-1.692z",
    opacity: 0.75
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M146.752 97.49l-5-.6-.864 2.191 5.117.603.747-2.194z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M146.752 97.49l-5-.6-.864 2.191 5.117.603.747-2.194z",
    opacity: 0.9
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M104.61 136.574v-2.846l6.037.715v2.846l-6.037-.715z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M110.646 134.443l1.242-3.481v3.248l-1.242 3.079v-2.846z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M111.889 130.962l-5.905-.711-1.374 3.477 6.037.715 1.242-3.481z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M104.61 136.574v-2.846l6.037.715v2.846l-6.037-.715z",
    opacity: 0.8
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.646 134.443l1.242-3.481v3.248l-1.242 3.079v-2.846z",
    opacity: 0.75
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M111.889 130.962l-5.905-.711-1.374 3.477 6.037.715 1.242-3.481z",
    opacity: 0.9
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M112.142 137.47v-2.842l6.037.712v2.846l-6.037-.716zM118.179 135.34l1.246-3.477v3.243l-1.246 3.079v-2.845z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M119.425 131.863l-5.909-.712-1.374 3.477 6.037.711 1.246-3.476z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M112.142 137.47v-2.842l6.037.712v2.846l-6.037-.716z",
    opacity: 0.8
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M118.179 135.34l1.246-3.477v3.243l-1.246 3.079v-2.845z",
    opacity: 0.75
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M119.425 131.863l-5.909-.712-1.374 3.477 6.037.711 1.246-3.476z",
    opacity: 0.9
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M85.542 146.103v-2.841l6.037.711v2.846l-6.037-.716z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M91.579 143.973l1.242-3.476v3.247l-1.242 3.075v-2.846z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M92.82 140.497l-5.903-.716-1.375 3.481 6.037.711 1.242-3.476z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M85.542 146.103v-2.841l6.037.711v2.846l-6.037-.716z",
    opacity: 0.8
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M91.579 143.973l1.242-3.476v3.247l-1.242 3.075v-2.846z",
    opacity: 0.75
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M92.82 140.497l-5.903-.716-1.375 3.481 6.037.711 1.242-3.476z",
    opacity: 0.9
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M93.074 147.003v-2.845l6.037.715v2.842l-6.037-.712zM99.111 144.873l1.246-3.48v3.247l-1.246 3.075v-2.842z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M100.357 141.393l-5.908-.712-1.375 3.477 6.037.715 1.246-3.48z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M93.074 147.003v-2.845l6.037.715v2.842l-6.037-.712z",
    opacity: 0.8
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M99.111 144.873l1.246-3.48v3.247l-1.246 3.075v-2.842z",
    opacity: 0.75
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M100.357 141.393l-5.908-.712-1.375 3.477 6.037.715 1.246-3.48z",
    opacity: 0.9
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M138.878 132.603v-2.846l6.033.715v2.842l-6.033-.711zM144.911 130.472l1.246-3.481v3.248l-1.246 3.075v-2.842z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M146.157 126.992l-5.908-.712-1.371 3.477 6.033.715 1.246-3.48z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M138.878 132.603v-2.846l6.033.715v2.842l-6.033-.711z",
    opacity: 0.8
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M144.911 130.472l1.246-3.481v3.248l-1.246 3.075v-2.842z",
    opacity: 0.75
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M146.157 126.992l-5.908-.712-1.371 3.477 6.033.715 1.246-3.48z",
    opacity: 0.9
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M136.511 138.463v-2.846l6.033.716v2.845l-6.033-.715zM142.544 136.332l1.246-3.48v3.247l-1.246 3.079v-2.846z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M143.79 132.852l-5.909-.712-1.37 3.477 6.033.715 1.246-3.48z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M136.511 138.463v-2.846l6.033.716v2.845l-6.033-.715z",
    opacity: 0.8
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M142.544 136.332l1.246-3.48v3.247l-1.246 3.079v-2.846z",
    opacity: 0.75
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M143.79 132.852l-5.909-.712-1.37 3.477 6.033.715 1.246-3.48z",
    opacity: 0.9
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M134.14 144.323v-2.846l6.037.715v2.846l-6.037-.715zM140.177 142.193l1.245-3.481v3.248l-1.245 3.078v-2.845z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M141.423 138.712l-5.909-.712-1.374 3.477 6.037.716 1.246-3.481z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M134.14 144.323v-2.846l6.037.715v2.846l-6.037-.715z",
    opacity: 0.8
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M140.177 142.193l1.245-3.481v3.248l-1.245 3.078v-2.845z",
    opacity: 0.75
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M141.423 138.712l-5.909-.712-1.374 3.477 6.037.716 1.246-3.481z",
    opacity: 0.9
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M131.772 150.183v-2.842l6.037.712v2.845l-6.037-.715zM137.809 148.053l1.246-3.477v3.244l-1.246 3.079v-2.846z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M139.055 144.576l-5.908-.716-1.375 3.481 6.037.711 1.246-3.476z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M131.772 150.183v-2.842l6.037.712v2.845l-6.037-.715z",
    opacity: 0.8
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M137.809 148.053l1.246-3.477v3.244l-1.246 3.079v-2.846z",
    opacity: 0.75
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M139.055 144.576l-5.908-.716-1.375 3.481 6.037.711 1.246-3.476z",
    opacity: 0.9
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M128.629 131.409v-2.842l6.037.711v2.846l-6.037-.715zM134.666 129.278l1.246-3.476v3.243l-1.246 3.079v-2.846z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M135.912 125.802l-5.908-.716-1.375 3.481 6.037.712 1.246-3.477z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M128.629 131.409v-2.842l6.037.711v2.846l-6.037-.715z",
    opacity: 0.8
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M134.666 129.278l1.246-3.476v3.243l-1.246 3.079v-2.846z",
    opacity: 0.75
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M135.912 125.802l-5.908-.716-1.375 3.481 6.037.712 1.246-3.477z",
    opacity: 0.9
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M126.262 137.269v-2.842l6.037.712v2.845l-6.037-.715zM132.299 135.139l1.246-3.477v3.248l-1.246 3.075v-2.846z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M133.545 131.662l-5.909-.711-1.374 3.476 6.037.712 1.246-3.477z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M126.262 137.269v-2.842l6.037.712v2.845l-6.037-.715z",
    opacity: 0.8
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M132.299 135.139l1.246-3.477v3.248l-1.246 3.075v-2.846z",
    opacity: 0.75
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M133.545 131.662l-5.909-.711-1.374 3.476 6.037.712 1.246-3.477z",
    opacity: 0.9
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M123.894 143.133v-2.846l6.037.716v2.841l-6.037-.711zM129.931 141.003l1.246-3.481v3.248l-1.246 3.074v-2.841zM131.177 137.522l-5.908-.711-1.375 3.476 6.037.716 1.246-3.481z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M123.894 143.133v-2.846l6.037.716v2.841l-6.037-.711z",
    opacity: 0.8
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M129.931 141.003l1.246-3.481v3.248l-1.246 3.074v-2.841z",
    opacity: 0.75
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M131.177 137.522l-5.908-.711-1.375 3.476 6.037.716 1.246-3.481z",
    opacity: 0.9
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M121.527 148.993v-2.846l6.037.716v2.842l-6.037-.712z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M127.564 146.863l1.246-3.481v3.248l-1.246 3.075v-2.842z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M128.81 143.382l-5.909-.711-1.374 3.477 6.037.715 1.246-3.481z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M121.527 148.993v-2.846l6.037.716v2.842l-6.037-.712z",
    opacity: 0.8
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M127.564 146.863l1.246-3.481v3.248l-1.246 3.075v-2.842z",
    opacity: 0.75
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M128.81 143.382l-5.909-.711-1.374 3.477 6.037.715 1.246-3.481z",
    opacity: 0.9
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M148.878 142.128v-2.234l4.751.562v2.235l-4.751-.563zM153.629 140.456l.977-2.737v2.553l-.977 2.419v-2.235z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M154.606 137.719l-4.647-.563-1.081 2.737 4.751.563.977-2.737z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M148.878 142.128v-2.234l4.751.562v2.235l-4.751-.563z",
    opacity: 0.8
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M153.629 140.456l.977-2.737v2.553l-.977 2.419v-2.235z",
    opacity: 0.75
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M154.606 137.719l-4.647-.563-1.081 2.737 4.751.563.977-2.737z",
    opacity: 0.9
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M146.507 148.72v-2.239l4.747.563v2.234l-4.747-.558z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M151.254 147.044l.981-2.737v2.552l-.981 2.42v-2.235z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M152.235 144.307l-4.647-.563-1.081 2.737 4.747.563.981-2.737z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M146.507 148.72v-2.239l4.747.563v2.234l-4.747-.558z",
    opacity: 0.8
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M151.254 147.044l.981-2.737v2.552l-.981 2.42v-2.235z",
    opacity: 0.75
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M152.235 144.307l-4.647-.563-1.081 2.737 4.747.563.981-2.737z",
    opacity: 0.9
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M95.522 135.396v-10.659l7.484.884v10.655l-7.484-.88z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M95.522 135.396v-10.659l7.484.884v10.655l-7.484-.88z",
    opacity: 0.8
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M103.006 125.621l.969-2.6v11.189l-.969 2.066v-10.655z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M103.006 125.621l.969-2.6v11.189l-.969 2.066v-10.655z",
    opacity: 0.75
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M103.974 123.02l-7.31-.876-1.142 2.592 7.484.885.968-2.601z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M103.974 123.02l-7.31-.876-1.142 2.592 7.484.885.968-2.601z",
    opacity: 0.9
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M57.692 99.571V86.967l4.313.482v12.601l-4.313-.479z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.692 99.571V86.967l4.313.482v12.601l-4.313-.479z",
    opacity: 0.8
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M62.005 87.45l.968-2.601v13.135l-.968 2.066v-12.6z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M62.005 87.45l.968-2.601v13.135l-.968 2.066v-12.6z",
    opacity: 0.75
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M62.973 84.849l-4.14-.475-1.141 2.593 4.313.482.968-2.6z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M62.973 84.849l-4.14-.475-1.141 2.593 4.313.482.968-2.6z",
    opacity: 0.9
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M62.487 99.13V88.015l2.283.245V99.38l-2.283-.25z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M62.487 99.13V88.015l2.283.245V99.38l-2.283-.25z",
    opacity: 0.8
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M64.77 88.261l.358-1.137v11.568l-.358.687V88.26z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64.77 88.261l.358-1.137v11.568l-.358.687V88.26z",
    opacity: 0.75
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M65.128 87.124l-2.139-.245-.502 1.137 2.283.246.358-1.138z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M65.128 87.124l-2.139-.245-.502 1.137 2.283.246.358-1.138z",
    opacity: 0.9
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M86.575 134.331v-10.66l7.484.881v10.659l-7.484-.88z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M86.575 134.331v-10.66l7.484.881v10.659l-7.484-.88z",
    opacity: 0.8
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M94.059 124.552l.972-2.597v11.19l-.972 2.066v-10.659z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M94.059 124.552l.972-2.597v11.19l-.972 2.066v-10.659z",
    opacity: 0.75
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M95.031 121.955l-7.31-.876-1.146 2.593 7.484.88.972-2.597z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M95.031 121.955l-7.31-.876-1.146 2.593 7.484.88.972-2.597z",
    opacity: 0.9
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M66.916 100.773v-3.191l6.765.8v3.191l-6.765-.8z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M73.68 98.382l1.4-3.899v3.642l-1.4 3.448v-3.19z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M75.08 94.483l-6.624-.8-1.54 3.899 6.765.8 1.398-3.9z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M66.916 100.773v-3.191l6.765.8v3.191l-6.765-.8z",
    opacity: 0.8
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M73.68 98.382l1.4-3.899v3.642l-1.4 3.448v-3.19z",
    opacity: 0.75
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M75.08 94.483l-6.624-.8-1.54 3.899 6.765.8 1.398-3.9z",
    opacity: 0.9
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M61.012 123.639l-4.847 2.798-3.883-2.227 5.097-2.942 3.633 2.371z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M61.012 123.639l-4.847 2.798-3.883-2.227 5.097-2.942 3.633 2.371z",
    opacity: 0.9
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M52.282 126.517v-2.307l3.883 2.227v2.319l-3.883-2.239z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M52.282 126.517v-2.307l3.883 2.227v2.319l-3.883-2.239z",
    opacity: 0.8
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M61.012 123.639v2.319l-4.847 2.798v-2.319l4.847-2.798z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M61.012 123.639v2.319l-4.847 2.798v-2.319l4.847-2.798z",
    opacity: 0.75
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M66.43 126.835l-4.847 2.797-3.879-2.227 5.096-2.938 3.63 2.368z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M66.43 126.835l-4.847 2.797-3.879-2.227 5.096-2.938 3.63 2.368z",
    opacity: 0.9
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M57.704 129.712v-2.307l3.879 2.227v2.319l-3.879-2.239z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.704 129.712v-2.307l3.879 2.227v2.319l-3.879-2.239z",
    opacity: 0.8
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M66.43 126.835v2.319l-4.847 2.798v-2.32l4.847-2.797z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M66.43 126.835v2.319l-4.847 2.798v-2.32l4.847-2.797z",
    opacity: 0.75
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M71.96 130.002l-4.847 2.793-3.882-2.222 5.096-2.943 3.634 2.372z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M71.96 130.002l-4.847 2.793-3.882-2.222 5.096-2.943 3.634 2.372z",
    opacity: 0.9
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M63.23 132.876v-2.303l3.883 2.222v2.324l-3.882-2.243z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M63.23 132.876v-2.303l3.883 2.222v2.324l-3.882-2.243z",
    opacity: 0.8
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M71.96 130.002v2.319l-4.847 2.798v-2.324l4.848-2.793z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M71.96 130.002v2.319l-4.847 2.798v-2.324l4.848-2.793z",
    opacity: 0.75
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M79.806 131.429l-4.847 2.797L71.076 132l5.097-2.938 3.633 2.367z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M79.806 131.429l-4.847 2.797L71.076 132l5.097-2.938 3.633 2.367z",
    opacity: 0.9
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M71.076 137.55V132l3.883 2.226v5.567l-3.883-2.243z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M71.076 137.55V132l3.883 2.226v5.567l-3.883-2.243z",
    opacity: 0.8
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M79.806 131.429v5.562l-4.847 2.802v-5.567l4.847-2.797z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M79.806 131.429v5.562l-4.847 2.802v-5.567l4.847-2.797z",
    opacity: 0.75
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M50.823 118.378l-5.253 1.966-3.883-2.223 5.507-2.11 3.629 2.367z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M50.823 118.378l-5.253 1.966-3.883-2.223 5.507-2.11 3.629 2.367z",
    opacity: 0.9
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M41.687 120.424v-2.303l3.883 2.222v2.323l-3.883-2.242z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.687 120.424v-2.303l3.883 2.222v2.323l-3.883-2.242z",
    opacity: 0.8
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M50.823 118.378v2.319l-5.253 1.97v-2.324l5.253-1.965z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M50.823 118.378v2.319l-5.253 1.97v-2.324l5.253-1.965z",
    opacity: 0.75
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M59.247 115.163l-5.257 1.969-3.883-2.226 5.507-2.111 3.633 2.368z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59.247 115.163l-5.257 1.969-3.883-2.226 5.507-2.111 3.633 2.368z",
    opacity: 0.9
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M50.107 117.212v-2.307l3.883 2.227v2.319l-3.883-2.239z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M50.107 117.212v-2.307l3.883 2.227v2.319l-3.883-2.239z",
    opacity: 0.8
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M59.247 115.163v2.323l-5.257 1.965v-2.319l5.257-1.969z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59.247 115.163v2.323l-5.257 1.965v-2.319l5.257-1.969z",
    opacity: 0.75
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M91.14 103.627v-3.36l9.824 1.158v3.36l-9.823-1.158z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M91.14 103.627v-3.36l9.824 1.158v3.36l-9.823-1.158z",
    opacity: 0.75
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M100.964 101.425l2.074-5.808v4.035l-2.074 5.133v-3.36z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M100.964 101.425l2.074-5.808v4.035l-2.074 5.133v-3.36z",
    opacity: 0.65
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M103.038 95.617l-9.606-1.158-2.291 5.808 9.823 1.157 2.074-5.807z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M103.038 95.617l-9.606-1.158-2.291 5.808 9.823 1.157 2.074-5.807z",
    opacity: 0.9
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M92.403 99.43V83.04l7.693.904v16.391l-7.693-.904z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M92.403 99.43V83.04l7.693.904v16.391l-7.693-.904z",
    opacity: 0.75
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M100.096 83.944l1.68-4.702v16.933l-1.68 4.16v-16.39z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M100.096 83.944l1.68-4.702v16.933l-1.68 4.16v-16.39z",
    opacity: 0.65
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M101.776 79.242l-7.516-.905-1.857 4.703 7.693.904 1.68-4.702z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M101.776 79.242l-7.516-.905-1.857 4.703 7.693.904 1.68-4.702z",
    opacity: 0.9
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M94.802 81.983v-8.935l4.197.495v8.935l-4.197-.495z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M94.802 81.983v-8.935l4.197.495v8.935l-4.197-.495z",
    opacity: 0.75
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M98.999 73.542l.916-2.564v9.232l-.916 2.267v-8.935z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M98.999 73.542l.916-2.564v9.232l-.916 2.267v-8.935z",
    opacity: 0.65
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M99.915 70.978l-4.104-.494-1.009 2.564 4.197.495.916-2.565z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M99.915 70.978l-4.104-.494-1.009 2.564 4.197.495.916-2.565z",
    opacity: 0.9
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M139.292 127.205v-25.829l7.697.905v25.828l-7.697-.904z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M139.292 127.205v-25.829l7.697.905v25.828l-7.697-.904z",
    opacity: 0.75
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M146.989 102.281l1.126-3.292v26.371l-1.126 2.749v-25.828z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M146.989 102.281l1.126-3.292v26.371l-1.126 2.749v-25.828z",
    opacity: 0.65
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M148.115 98.989l-7.521-.904-1.302 3.291 7.697.905 1.126-3.292z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M148.115 98.989l-7.521-.904-1.302 3.291 7.697.905 1.126-3.292z",
    opacity: 0.9
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M151.744 135.444v-23.915l6.708.743v23.919l-6.708-.747z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M151.744 135.444v-23.915l6.708.743v23.919l-6.708-.747z",
    opacity: 0.75
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M158.452 112.273l1.512-4.04v24.743l-1.512 3.216v-23.919z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M158.452 112.273l1.512-4.04v24.743l-1.512 3.216v-23.919z",
    opacity: 0.65
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M159.964 108.233l-6.443-.743-1.777 4.039 6.708.744 1.512-4.04z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M159.964 108.233l-6.443-.743-1.777 4.039 6.708.744 1.512-4.04z",
    opacity: 0.9
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M159.208 134.761v-21.6l3.553.382v21.6l-3.553-.382z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M159.208 134.761v-21.6l3.553.382v21.6l-3.553-.382z",
    opacity: 0.75
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M162.761 113.543l.551-1.773v22.311l-.551 1.061v-21.599z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M162.761 113.543l.551-1.773v22.311l-.551 1.061v-21.599z",
    opacity: 0.65
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M163.312 111.77l-3.324-.377-.78 1.768 3.553.382.551-1.773z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M163.312 111.77l-3.324-.377-.78 1.768 3.553.382.551-1.773z",
    opacity: 0.9
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M26.852 109.097l9.799 5.655v3.075l-9.8-5.655v-3.075z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M26.852 109.097l9.799 5.655v3.075l-9.8-5.655v-3.075z",
    opacity: 0.35
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M46.446 112.172v-3.075l-9.795 5.655v3.075"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M46.446 109.097l-9.795 5.655v3.075l9.795-5.655v-3.075z",
    opacity: 0.15
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M46.446 109.098l-9.795-5.656-9.8 5.656 9.8 5.655 9.795-5.655z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M46.446 109.098l-9.795-5.656-9.8 5.656 9.8 5.655 9.795-5.655z",
    opacity: 0.5
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M26.852 108.623l9.799 5.655v-.94l-9.8-5.655v.94z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M26.852 108.623l9.799 5.655v-.94l-9.8-5.655v.94z",
    opacity: 0.35
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M36.65 114.278l9.796-5.655v-.94l-9.795 5.655v.94z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M36.65 114.278l9.796-5.655v-.94l-9.795 5.655v.94z",
    opacity: 0.15
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M46.446 107.683l-9.795-5.656-9.8 5.656 9.8 5.655 9.795-5.655z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M46.446 107.683l-9.795-5.656-9.8 5.656 9.8 5.655 9.795-5.655z",
    opacity: 0.5
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M26.852 107.104l9.799 5.655v-.941l-9.8-5.655v.941z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M26.852 107.104l9.799 5.655v-.941l-9.8-5.655v.941z",
    opacity: 0.35
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M36.65 112.759l9.796-5.655v-.941l-9.795 5.655v.941z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M36.65 112.759l9.796-5.655v-.941l-9.795 5.655v.941z",
    opacity: 0.15
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M46.446 106.163l-9.795-5.655-9.8 5.655 9.8 5.656 9.795-5.656z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M46.446 106.163l-9.795-5.655-9.8 5.655 9.8 5.656 9.795-5.656z",
    opacity: 0.5
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M36.65 110.758V87.011l-8.162-4.71v23.742l8.163 4.715z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M36.65 87.011l8.164-4.71v23.742l-8.163 4.715V87.011z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M44.814 82.3l-8.163-4.714-8.164 4.715 8.164 4.71 8.163-4.71z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M44.814 82.3l-8.163-4.714-8.164 4.715 8.164 4.71 8.163-4.71z",
    opacity: 0.4
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M36.65 110.758V87.011l-8.162-4.71v23.742l8.163 4.715z",
    opacity: 0.2
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M36.65 86.07v-20l-6.53-3.858V82.3l6.53 3.77zM36.65 86.07v-20l6.528-3.858V82.3l-6.527 3.77z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M43.178 62.212l-6.527-3.726-6.532 3.726 6.532 3.859 6.527-3.859z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M43.178 62.212l-6.527-3.726-6.532 3.726 6.532 3.859 6.527-3.859z",
    opacity: 0.4
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M36.65 86.07v-20l-6.53-3.858V82.3l6.53 3.77z",
    opacity: 0.2
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M36.65 64.612v-2.826l4.08-2.36v2.83l-4.08 2.356z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M32.567 62.256v-2.83l4.084 2.36v2.826l-4.084-2.356z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M32.567 62.256v-2.83l4.084 2.36v2.826l-4.084-2.356z",
    opacity: 0.2
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M40.73 59.427l-4.08-2.356-4.083 2.356 4.084 2.359 4.08-2.36z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M40.73 59.427l-4.08-2.356-4.083 2.356 4.084 2.359 4.08-2.36z",
    opacity: 0.4
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M36.65 60.841V47.646l2.449 11.78-2.448 1.415z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M36.65 60.841V47.646l2.449 11.78-2.448 1.415z",
    opacity: 0.1
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M34.17 59.427l2.48-11.781v13.195l-2.48-1.414z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M34.17 59.427l2.48-11.781v13.195l-2.48-1.414z",
    opacity: 0.25
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M142.037 155.509a.293.293 0 0 1-.092-.021c-.052-.028-5.458-2.741-13.77-3.123-8.312-.381-12.275 1.206-12.315 1.206a.204.204 0 0 1-.266-.265l12.223-30.209-28.577-3.332a.212.212 0 0 1-.088-.032.204.204 0 0 1-.077-.25l4.53-11.206-57.822-6.865a.186.186 0 0 1-.077-.023.196.196 0 0 1-.1-.202.208.208 0 0 1 .225-.181l58.091 6.91a.202.202 0 0 1 .149.1.203.203 0 0 1 0 .181l-4.534 11.21 28.577 3.332a.211.211 0 0 1 .153.096.214.214 0 0 1 0 .185l-12.154 30.029c1.242-.402 5.12-1.407 12.058-1.09 8.404.382 13.882 3.136 13.939 3.164a.195.195 0 0 1 .101.118.176.176 0 0 1 .009.079.19.19 0 0 1-.022.076.205.205 0 0 1-.161.113z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M29.613 29.57v-1.205c.02-1.545.277-3.079.764-4.546 1.242-3.838 3.858-7.512 6.885-9.244 1.925-1.114 3.681-1.25 5.028-.583l-2.649-1.523a3.918 3.918 0 0 0-2.572-.627c-.129 0-.258.024-.402.044-.136.016-.27.04-.402.072-.136.03-.27.066-.402.109a6.768 6.768 0 0 0-.832.305c-.14.06-.281.133-.426.201-.145.069-.29.153-.43.233-4.2 2.428-7.62 8.602-7.62 13.827v1.206c0 5.197 6.989 10.852 6.989 10.852l2.813 1.607a1.202 1.202 0 0 1-.14-.108c-2.07-1.974-6.604-6.62-6.604-10.62zm8.344-10.928c.025.133.04.267.048.402v.141c.004.079.004.158 0 .237 0 2.436-1.708 5.402-3.822 6.62l-.23.124c-.076.04-.152.073-.224.105l-.221.092h-.025c.33 1.865 1.882 2.517 3.763 1.44 2.11-1.206 3.818-4.189 3.818-6.625.016-2.158-1.33-3.183-3.107-2.536z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M29.613 29.57v-1.205c.02-1.545.277-3.079.764-4.546 1.242-3.838 3.858-7.512 6.885-9.244 1.925-1.114 3.681-1.25 5.028-.583l-2.649-1.523a3.918 3.918 0 0 0-2.572-.627c-.129 0-.258.024-.402.044-.136.016-.27.04-.402.072-.136.03-.27.066-.402.109a6.768 6.768 0 0 0-.832.305c-.14.06-.281.133-.426.201-.145.069-.29.153-.43.233-4.2 2.428-7.62 8.602-7.62 13.827v1.206c0 5.197 6.989 10.852 6.989 10.852l2.813 1.607a1.202 1.202 0 0 1-.14-.108c-2.07-1.974-6.604-6.62-6.604-10.62z",
    opacity: 0.3
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M37.957 18.643c.025.132.04.267.048.401v.141c.005.08.005.158 0 .237 0 2.436-1.708 5.402-3.822 6.62l-.23.125c-.076.04-.152.072-.224.104l-.221.093h-.024c.33 1.865 1.88 2.516 3.762 1.439 2.11-1.206 3.818-4.189 3.818-6.624.016-2.159-1.33-3.183-3.107-2.536z",
    opacity: 0.5
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M44.903 19.559c0-5.197-3.421-7.436-7.637-4.996-4.216 2.44-7.637 8.625-7.637 13.822v1.206c0 4.02 4.534 8.646 6.62 10.57a1.028 1.028 0 0 0 1.608-.305c1.8-3.685 7.046-14.79 7.046-19.095v-1.202zm-7.637 8.243c-2.11 1.206-3.823.234-3.823-2.206s1.705-5.394 3.815-6.6c2.11-1.206 3.822-.233 3.822 2.207s-1.712 5.382-3.822 6.6h.008z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M44.903 19.559c0-5.197-3.421-7.436-7.637-4.996-4.216 2.44-7.637 8.625-7.637 13.822v1.206c0 4.02 4.534 8.646 6.62 10.57a1.028 1.028 0 0 0 1.608-.305c1.8-3.685 7.046-14.79 7.046-19.095v-1.202zm-7.637 8.243c-2.11 1.206-3.823.234-3.823-2.206s1.705-5.394 3.815-6.6c2.11-1.206 3.822-.233 3.822 2.207s-1.712 5.382-3.822 6.6h.008zM95.345 62.264v-.402a4.928 4.928 0 0 1 .253-1.495 5.583 5.583 0 0 1 2.263-3.043 1.728 1.728 0 0 1 1.652-.192l-.872-.503a1.282 1.282 0 0 0-.72-.209h-.265a.766.766 0 0 0-.133.024l-.128.032a1.91 1.91 0 0 0-.274.105l-.14.064-.145.076c-1.387.804-2.512 2.814-2.512 4.542v.402c0 1.709 2.299 3.565 2.299 3.565l.928.527-.044-.036c-.67-.62-2.162-2.143-2.162-3.457zm2.745-3.593c.002.044.002.088 0 .133v.044a.54.54 0 0 1 0 .08 2.779 2.779 0 0 1-1.258 2.175l-.072.04-.077.036-.072.028c.105.611.615.824 1.234.47a2.782 2.782 0 0 0 1.254-2.174c.016-.716-.426-1.045-1.009-.832z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M95.345 62.264v-.402a4.928 4.928 0 0 1 .253-1.495 5.583 5.583 0 0 1 2.263-3.043 1.728 1.728 0 0 1 1.652-.192l-.872-.503a1.282 1.282 0 0 0-.72-.209h-.265a.766.766 0 0 0-.133.024l-.128.032a1.91 1.91 0 0 0-.274.105l-.14.064-.145.076c-1.387.804-2.512 2.814-2.512 4.542v.402c0 1.709 2.299 3.565 2.299 3.565l.928.527-.044-.036c-.67-.62-2.162-2.143-2.162-3.457z",
    opacity: 0.6
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M98.078 58.67c.002.045.002.09 0 .133v.125a2.773 2.773 0 0 1-1.254 2.175l-.076.04-.073.036-.076.028c.108.611.619.824 1.234.47a2.773 2.773 0 0 0 1.254-2.174c.016-.715-.422-1.045-1.009-.832z",
    opacity: 0.6
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M100.373 58.972c0-1.708-1.125-2.443-2.512-1.643s-2.492 2.837-2.492 4.545v.402c0 1.315 1.487 2.838 2.174 3.473a.338.338 0 0 0 .535-.1c.59-1.206 2.315-4.86 2.315-6.275l-.02-.402zm-2.512 2.71c-.695.401-1.258.076-1.258-.724a2.777 2.777 0 0 1 1.258-2.17c.691-.402 1.254-.077 1.254.727a2.776 2.776 0 0 1-1.254 2.166z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M100.373 58.972c0-1.708-1.125-2.443-2.512-1.643s-2.492 2.837-2.492 4.545v.402c0 1.315 1.487 2.838 2.174 3.473a.338.338 0 0 0 .535-.1c.59-1.206 2.315-4.86 2.315-6.275l-.02-.402zm-2.512 2.71c-.695.401-1.258.076-1.258-.724a2.777 2.777 0 0 1 1.258-2.17c.691-.402 1.254-.077 1.254.727a2.776 2.776 0 0 1-1.254 2.166z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M100.373 58.972c0-1.708-1.125-2.443-2.512-1.643s-2.492 2.837-2.492 4.545v.402c0 1.315 1.487 2.838 2.174 3.473a.338.338 0 0 0 .535-.1c.59-1.206 2.315-4.86 2.315-6.275l-.02-.402zm-2.512 2.71c-.695.401-1.258.076-1.258-.724a2.777 2.777 0 0 1 1.258-2.17c.691-.402 1.254-.077 1.254.727a2.776 2.776 0 0 1-1.254 2.166z",
    opacity: 0.8
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M142.158 88.53v-.401a4.936 4.936 0 0 1 .253-1.496 5.583 5.583 0 0 1 2.263-3.042 1.732 1.732 0 0 1 1.652-.193l-.872-.495a1.294 1.294 0 0 0-.724-.209h-.249l-.128.025-.133.032c-.093.029-.185.064-.273.104l-.137.064-.145.077c-1.386.804-2.512 2.834-2.512 4.542v.402c0 1.708 2.299 3.565 2.299 3.565l.929.526-.045-.036c-.687-.65-2.178-2.17-2.178-3.465zm2.745-3.593c.002.044.002.089 0 .133v.044a.54.54 0 0 1 0 .08 2.77 2.77 0 0 1-1.258 2.175l-.072.04-.077.036-.072.028c.109.611.619.804 1.238.47a2.781 2.781 0 0 0 1.254-2.174c.012-.727-.43-1.065-1.013-.856v.024z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M142.158 88.53v-.401a4.936 4.936 0 0 1 .253-1.496 5.583 5.583 0 0 1 2.263-3.042 1.732 1.732 0 0 1 1.652-.193l-.872-.495a1.294 1.294 0 0 0-.724-.209h-.249l-.128.025-.133.032c-.093.029-.185.064-.273.104l-.137.064-.145.077c-1.386.804-2.512 2.834-2.512 4.542v.402c0 1.708 2.299 3.565 2.299 3.565l.929.526-.045-.036c-.687-.65-2.178-2.17-2.178-3.465z",
    opacity: 0.6
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M144.891 84.913c.002.044.002.089 0 .133v.124a2.768 2.768 0 0 1-1.254 2.175l-.076.04-.073.036-.076.028c.109.611.619.804 1.234.47a2.776 2.776 0 0 0 1.254-2.174c.016-.703-.426-1.04-1.009-.832z",
    opacity: 0.6
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M147.186 85.219c0-1.709-1.125-2.444-2.512-1.644s-2.516 2.837-2.516 4.546v.401c0 1.315 1.491 2.838 2.178 3.473a.342.342 0 0 0 .293.085.337.337 0 0 0 .242-.185c.591-1.206 2.315-4.86 2.315-6.274v-.402zm-2.512 2.709c-.695.402-1.258.076-1.258-.724a2.78 2.78 0 0 1 1.258-2.178c.691-.402 1.254-.077 1.254.727a2.78 2.78 0 0 1-1.254 2.175z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M147.186 85.219c0-1.709-1.125-2.444-2.512-1.644s-2.516 2.837-2.516 4.546v.401c0 1.315 1.491 2.838 2.178 3.473a.342.342 0 0 0 .293.085.337.337 0 0 0 .242-.185c.591-1.206 2.315-4.86 2.315-6.274v-.402zm-2.512 2.709c-.695.402-1.258.076-1.258-.724a2.78 2.78 0 0 1 1.258-2.178c.691-.402 1.254-.077 1.254.727a2.78 2.78 0 0 1-1.254 2.175z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M147.186 85.219c0-1.709-1.125-2.444-2.512-1.644s-2.516 2.837-2.516 4.546v.401c0 1.315 1.491 2.838 2.178 3.473a.342.342 0 0 0 .293.085.337.337 0 0 0 .242-.185c.591-1.206 2.315-4.86 2.315-6.274v-.402zm-2.512 2.709c-.695.402-1.258.076-1.258-.724a2.78 2.78 0 0 1 1.258-2.178c.691-.402 1.254-.077 1.254.727a2.78 2.78 0 0 1-1.254 2.175z",
    opacity: 0.8
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M189.377 177.124v-3.525l-26.339-6.057v3.521a.506.506 0 0 0 .121.289l10.253 14.381c.253.354.527.294.607-.132l1.298-6.749a1.065 1.065 0 0 1 .933-.803l12.789-.804c.225-.045.334-.077.338-.121z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M189.377 177.124v-3.525l-26.339-6.057v3.521a.506.506 0 0 0 .121.289l10.253 14.381c.253.354.527.294.607-.132l1.298-6.749a1.065 1.065 0 0 1 .933-.803l12.789-.804c.225-.045.334-.077.338-.121z",
    opacity: 0.3
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M173.641 185.938c.173.081.326-.032.382-.333l1.298-6.749c.036-.159.109-.308.213-.434v-4.956l-1.893 2.774v9.698z",
    opacity: 0.2
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "#7764F5",
    d: "M174.023 182.076l1.298-6.728a1.063 1.063 0 0 1 .933-.804l12.793-.804c.431-.028.439-.133 0-.233l-25.595-6.085c-.422-.101-.558.104-.305.458l10.253 14.381c.27.321.543.241.623-.185z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation4);
export default __webpack_public_path__ + "static/media/information_4.18a5a40259ab1262260dac1b048353e3.svg";
export { ForwardRef as ReactComponent };